import App from './App.vue';
import routes from './router/creator';
import createApp from './common.js';

createApp(App, routes).$mount('#creator-app');

window.addEventListener('hashchange', () => window.location.reload(), false);
